import { transformPageEntryV1ToV2 } from './transformPageEntryV1ToV2.js';

const transformComponentEntryV1ToV2 = (component, entry) => {
  return {
    version: 2,
    originalVersion: 1,
    shared: false,
    currentPageId: void 0,
    pages: entry.pages.map((pageEntry, pageIndex) => {
      const page = component.pages.find(
        (it) => it.id === pageIndex.toString()
      );
      return page !== void 0 ? transformPageEntryV1ToV2(page, pageEntry, pageIndex) : void 0;
    }).filter(isPageEntryDefined)
  };
};
function isPageEntryDefined(pageEntry) {
  return pageEntry !== void 0;
}

export { transformComponentEntryV1ToV2 };
//# sourceMappingURL=transformComponentEntryV1ToV2.js.map
